import { TimesLight } from 'emerald-icons/dist/TimesLight';
import React from 'react';
import {
    ClearButton,
    clearButtonIconCss,
    SidePanelFrameLeftContent,
    SidePanelFrameMidSlot,
    SidePanelFrameRoot,
    SidePanelFrameTopBotSlot
} from './SidePanelFrame.styles';

export function SidePanelFrame({
    top,
    middle,
    bottom,
    visible = true,
    clearable,
    clearAllAriaLabel,
    onClearClick,
    children,
    ...otherProps
}) {
    return (
        <SidePanelFrameRoot
            visible={visible}
            {...otherProps}
        >
            {children}
            <SidePanelFrameLeftContent>
                <SidePanelFrameTopBotSlot>
                    {visible && top}
                </SidePanelFrameTopBotSlot>
                <SidePanelFrameMidSlot>
                    {visible && middle}
                </SidePanelFrameMidSlot>
                <SidePanelFrameTopBotSlot>
                    {visible && bottom}
                </SidePanelFrameTopBotSlot>
            </SidePanelFrameLeftContent>
            {clearable && visible && (
                <ClearButton
                    aria-label={clearAllAriaLabel}
                    onClick={onClearClick}
                >
                    <TimesLight css={clearButtonIconCss} />
                </ClearButton>
            )}
        </SidePanelFrameRoot>
    );
}
